import arrow from "../Design&DevApproch/Dev&DesignImages/arrowi.png"
import arrowbg from "../Design&DevApproch/Dev&DesignImages/arrowbg.png"
import rocket from "../Design&DevApproch/Dev&DesignImages/rocket.png"
import rocketbg from "../Design&DevApproch/Dev&DesignImages/black.png"
import done from "../Design&DevApproch/Dev&DesignImages/doneI.png"
import donebg from "../Design&DevApproch/Dev&DesignImages/donebg.png"
import heart from "../Design&DevApproch/Dev&DesignImages/hearti.png"
import heartbg from "../Design&DevApproch/Dev&DesignImages/heartbg.png"
import locki from "../Design&DevApproch/Dev&DesignImages/locki.png"
import lockbg from "../Design&DevApproch/Dev&DesignImages/lockbg.png"
import shieldi from "../Design&DevApproch/Dev&DesignImages/shieldi.png"
import shieldbg from "../Design&DevApproch/Dev&DesignImages/shieldbg.png"

export const DesignData=[{
    id:1,
    backgroundImage:rocketbg,
    image:rocket,
    title:"UX Driven Engineering",
    color:"text-[#28272e]"
},
{
    id:2,
    backgroundImage:arrowbg,
    image:arrow,
    title:"Developing Shared Understanding",
    color:"text-[#62cbf3]"
},{
    id:3,
    backgroundImage:donebg,
    image:done,
    title:"Proven Experience and Expertise",
    color:"text-[#ff7da9]"

},{
    id:4,
    backgroundImage:heartbg,
    image:heart,
    title:"Security & Intellectual Property (IP)",
    color:"text-[#51e0cf]"

},{
    id:5,
    backgroundImage:lockbg,
    image:locki,
    title:"Code Reviews",
    color:"text-[#fdd762]"

},{
    id:6,
    backgroundImage:shieldbg,
    image:shieldi,
    title:"Quality Assurance & Testing",
    color:"text-[#cf4c7f]"

}]